import React, { useContext, useEffect, useState } from "react";
import { BannerContext } from "../../contexts/BannerDimensionsContext";
import "./index.css";
import CompareIcon from "@material-ui/icons/Compare";

function RightMenu() {
  const {
    listaReplicas,
    fullScreenRight,
    mirrorActive,
    replicaActive,
  } = useContext(BannerContext);

  var disabled = true;
  listaReplicas.forEach((element) => {
    if (element.pack) {
      disabled = false;
    }
  });

  const [divWidth, setDivWidth] = useState("350px");

  useEffect(() => {
    function handleResize() {
      if (!fullScreenRight) {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1800) {
          setDivWidth("350px");
        } else if (windowWidth >= 1600) {
          setDivWidth("300px");
        } else if (windowWidth >= 1300) {
          setDivWidth("250px");
        } else if (windowWidth >= 1200) {
          setDivWidth("210px");
        } else {
          setDivWidth("350px");
        }
      }
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [fullScreenRight]);
  return (
    <div
      className="containerRight"
      style={{
        width: fullScreenRight ? "0px" : divWidth,
        minWidth: fullScreenRight ? "0px" : divWidth,
      }}
    >
      {mirrorActive &&
        (listaReplicas.length > 0 ? (
          <div className="containerTexts">
            <span className="textPropertiesRightMenu">Propriedades</span>
            <span className="messageNoFormat">
              Feche o{" "}
              <span style={{ color: "#643D84", fontWeight: "bold" }}>
                Espelho
              </span>
              <CompareIcon
                style={{ margin: "0 0 -6px 2px", fill: "#643D84" }}
              />{" "}
              para habilitar as propriedades
            </span>
          </div>
        ) : (
          <div className="containerTexts">
            <span className="textPropertiesRightMenu">Propriedades</span>
            <span className="messageNoFormat">
              Selecione um formato e feche o{" "}
              <span style={{ color: "#643D84", fontWeight: "bold" }}>
                Espelho
              </span>
              <CompareIcon
                style={{ margin: "0 0 -6px 2px", fill: "#643D84" }}
              />{" "}
              para habilitar as propriedades
            </span>
          </div>
        ))}

      {!mirrorActive &&
        (listaReplicas.length > 0 ? (
          <div
            className="containerTexts"
            style={{
              opacity:
                replicaActive ===
                listaReplicas[0].width + "x" + listaReplicas[0].height
                  ? "0%"
                  : "100%",
            }}
          >
            <span className="textPropertiesRightMenu">Propriedades</span>
            <span className="messageNoFormat">
              Selecione uma aba de formato para trabalhar
            </span>
          </div>
        ) : (
          <div className="containerTexts">
            <span className="textPropertiesRightMenu">Propriedades</span>
            <span className="messageNoFormat">
              Selecione um formato para habilitar as propriedades
            </span>
          </div>
        ))}
    </div>
  );
}

export default RightMenu;
